module.exports = __webpack_public_path__ + "static/media/ICONS-INDUSTRIAL_TECHNOLOGY.99583191.svg";